import React, {useState, useEffect} from "react";
import axios from "axios";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import Card from "../../Components/Cards/Card";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";
import {useForm} from "react-hook-form";
import FileInput from "../../Components/Inputs/FileInput";
import {useSelector} from "react-redux";
import swal from "sweetalert";

export default function () {
  const user = useSelector(state => state.user);
  const isAdmin = user?.roles?.includes('Super Admin');

  const {handleSubmit, control, reset} = useForm({
    defaultValues: {shop_id: null, products: null}
  });
  const [errors, setErrors] = useState({});
  const [shops, setShops] = useState([]);

  const [templateLink, setTemplateLink] = useState(null);

  useEffect(() => {
    axios.post(`/product/export_urls`).then(res => {
      setTemplateLink(res?.data?.main);
    });

    if (isAdmin) {
      axios.get(`/shops/list`).then(res => {
        setShops(res.data.shops);
      });
    }
  }, []);

  const importProducts = data => {
    let formData = new FormData;

    formData.append('shop_id', data.shop_id || '')
    formData.append('products', data.products || '');

    axios.post('/product/import', formData).then(res => {
      swal(res.data.message, {
        icon: "success",
      });

      reset({});
      setErrors({});
    }).catch(error => {
      if (error.response) {
        setErrors(error.response.data.errors || {});
      } else {
        swal(error.message, {
          icon: "error",
        });
      }
    });
  }

  const downloadCategories = () => {
    axios.get(`/product/export-categories`, {responseType: 'blob'}).then(res => {
      let url = window.URL.createObjectURL(new Blob([res.data]));
      let link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'categories.xlsx');
      document.body.appendChild(link);
      link.click();
    });
  }

  return (
    <Card title="Import products">
      {templateLink && (
        <a href={templateLink} className="btn btn-primary me-2 mb-4 mt-1 download_product_template">
          <i className="fas fa-download"></i> Products template
        </a>
      )}
      <button onClick={() => downloadCategories()} className="btn btn-primary me-2 mb-4 mt-1 download_product_template">
        <i className="fas fa-download"></i> Category codes
      </button>

      <form className="form w-100 row" onSubmit={handleSubmit(importProducts)}>
        {isAdmin && (
          <ReactSelectInput
            label="Shop"
            name="shop_id"
            control={control}
            errorMessage={errors?.shop_id}
            options={shops}
            inputClassName='mt-5'
          />
        )}

        <FileInput
          label="Products file"
          name="products"
          control={control}
          errorMessage={errors?.products}
        />

        <div className="col-12">
          <SubmitButton
            title="Import"
            classes="w-auto d-inline-block mt-3"
          />
        </div>
      </form>
    </Card>
  );
}